import Cookies from "universal-cookie";
import { teamAwareGet, teamAwarePost, teamAwarePut } from "../utils/teamApiHelper";

function getToken() {
    const cookies = new Cookies();
    return cookies.get("token");
}

function authHeaders() {
    return { headers: { authorization: `Bearer ${getToken()}` } };
}

// Participants are the team-wide identifiers attributed to questionnaire
// responses, conference participants and analysis speakers.
export function getParticipants(search = "") {
    const query = search ? `?search=${encodeURIComponent(search)}` : "";
    const url = process.env.REACT_APP_API_BASE_URL + `/team/{team_uuid}/participants${query}`;
    return teamAwareGet(url, authHeaders());
}

export function createParticipant(data) {
    const url = process.env.REACT_APP_API_BASE_URL + `/team/{team_uuid}/participants`;
    return teamAwarePost(url, data, authHeaders());
}

export function updateParticipant(participantUuid, data) {
    const url = process.env.REACT_APP_API_BASE_URL + `/team/{team_uuid}/participants/${participantUuid}`;
    return teamAwarePut(url, data, authHeaders());
}

export function getParticipantAppearances(participantUuid) {
    const url = process.env.REACT_APP_API_BASE_URL + `/team/{team_uuid}/participants/${participantUuid}`;
    return teamAwareGet(url, authHeaders());
}
